var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"recruitment-button",attrs:{"loading":_vm.loading,"disabled":_vm.loading,"color":"primary"},on:{"click":_vm.fetchRecruitmentInfo}},[_vm._v(" 获取近四天爱私益校招信息 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }